<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><a href="/item-table">{{ $t('product.catalogue') }}</a></li>
					<li><span>{{ $t('export.history') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { ExportManager, getExportReport } from '@/core/migration/ExportManager'
import { resizeTableHeight, Table } from '@/core/support_gui_components/table/table'
import { getFormattedDateTime } from '@/core/shared'

export default {
	name: 'Export',
	metaInfo () {
		return {
			title: this.$t('export')
		}
	},
	mounted () {
		let vm = this
		let tableColumns = [
			{
				'title': 'export.id',
				'columnName': 'id'
			},
			{
				'title': 'export.name',
				'columnName': 'name'
			},
			{
				'title': 'migration.user',
				'columnName': 'creator'
			},
			{
				'title': 'date',
				'columnName': 'date'
			},
			{
				'title': 'export.status',
				'columnName': 'statusLbl'
			},
			{
				'title': 'migration.result',
				'columnName': 'resultUri'
			},
			{
				'title': 'migration.report',
				'columnName': 'reportUri'
			},
			{
				'title': 'debug.archive',
				'columnName': 'debug_link'
			}
		]

		let exportManager = new ExportManager()
		exportManager.loadExportsHistory()

		this.$store.dispatch(USER_CONFIG, 'exportsTable.tableState')
			.then((config) => {
				window.getExportReport = getExportReport
				window.exportHistoryTable = new Table('exportsTable',
					{
						selector: '#table',
						columns: tableColumns,
						restoringSupport: true,
					},

					null,

					function (data) {
						_.each(data, function (value, key) {
							var date = new Date(value['dateCreate'])
							value['date'] = getFormattedDateTime(date)

							if (value['status'] == true) {
								var resultUri = '/export/' + value['id'] + '/result'
								value['resultUri'] = '<a onclick="downloadManager(\'' + resultUri + '\')">' + 'export/' + value['id'] + '/result' + '</a>'
								value['statusLbl'] = vm.$t('success')
								value['reportUri'] = '<a class="report-link" onclick="getExportReport(' + value['id'] + ',' + value['status'] + ')">' + vm.$t('migration.report') + '</a>'
							}
							if (value['status'] == false) {
								value['statusLbl'] = vm.$t('error')
								value['reportUri'] = '<a class="report-link" onclick="getExportReport(' + value['id'] + ',' + value['status'] + ')">' + vm.$t('migration.report') + '</a>'
							}
							if (value['status'] == null) {
								value['statusLbl'] = '<span class=\'loading fa fa-refresh fa-spin\'></span>'
							} else {
								if (value['debug'] == true) {
									value['debug_link'] = '<a onclick="downloadManager(\'/export/debug?exportId=' + value['id'] + '\')">' + vm.$t('archive') + '</a>'
								}
							}
						})
					})
				exportHistoryTable.setSavedState(config)
				exportHistoryTable.setData(exportManager.exportsHistory)
				exportHistoryTable.initTable()

				exportManager.checkAllExportSuccess(function (data) {
					exportHistoryTable.updateData(data)
				})
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG exportsTable', error)
			})

		$(window).resize(function () {
			resizeTableHeight()
			exportHistoryTable.frozenTableElements.setFrozenHeaderCellsWidth()
		})
	}
}
</script>

<style scoped>

</style>
